// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/accolades-list-blocks/accolades-list-blocks.component.scss
// module id = 74
// module chunks = 0